import React from "react";
import ReactDOM from "react-dom/client";

// Suppress ResizeObserver timing errors (harmless browser warnings that Radix UI Select triggers, which Webpack Dev Server captures as crashes)
if (typeof window !== "undefined") {
  if (window.ResizeObserver) {
    const OriginalResizeObserver = window.ResizeObserver;
    window.ResizeObserver = class ResizeObserver extends OriginalResizeObserver {
      constructor(callback) {
        super((entries, observer) => {
          window.requestAnimationFrame(() => {
            try {
              callback(entries, observer);
            } catch (e) {}
          });
        });
      }
    };
  }
  window.addEventListener("error", (e) => {
    if (e.message && (e.message.includes("ResizeObserver loop completed") || e.message.includes("ResizeObserver loop limit exceeded"))) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  });
}
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// PWA: register service worker for installability + offline shell (production only)
if ("serviceWorker" in navigator) {
  if (process.env.NODE_ENV === "production" && window.location.hostname !== "localhost" && window.location.hostname !== "127.0.0.1") {
    window.addEventListener("load", () => {
      navigator.serviceWorker.register("/sw.js").then((reg) => {
        // Check for updates periodically
        setInterval(() => {
          reg.update();
        }, 60 * 1000); // Check every minute
      }).catch(() => {});
    });

    // Automatically reload when a new service worker takes over control
    let refreshing = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (!refreshing) {
        refreshing = true;
        window.location.reload();
      }
    });
  } else {
    // Unregister any active service worker in development to avoid caching local changes
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      for (let registration of registrations) {
        registration.unregister().then((ok) => {
          if (ok) console.log("[PWA] Service Worker unregistered in development mode.");
        });
      }
    });
    // Clear all caches in development to ensure fresh assets
    if (window.caches) {
      caches.keys().then((names) => {
        for (let name of names) {
          caches.delete(name).then(() => {
            console.log(`[PWA] Cache cleared in development: ${name}`);
          });
        }
      });
    }
  }
}

